import { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase/config.js';
import { setSentryContext, clearSentryContext } from '../lib/sentryInit.js';

const AuthCtx = createContext({ user: null, claims: {}, loading: true });

export function AuthProvider({ children }) {
  const [state, setState] = useState({ user: null, claims: {}, loading: true });

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (!u) {
        setState({ user: null, claims: {}, loading: false });
        clearSentryContext();
        return;
      }
      const tokenResult = await u.getIdTokenResult(true);
      const claims = tokenResult.claims || {};
      setState({ user: u, claims, loading: false });
      // Sentry context: UID + gymId + role only. PII (email/name) is
      // scrubbed by sentryInit.scrubEvent regardless, but don't even
      // attach it in the first place.
      setSentryContext({ uid: u.uid, gymId: claims.gymId, role: claims.role });
    });
    return unsub;
  }, []);

  return <AuthCtx.Provider value={state}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}
